
    <div id="mySideLogin" class="sideRegister" tabindex="-1">
        <a href="javascript:void(0)" class="closebtn" (click)="closeLogin()">
            <i class="fa fa-close"></i>
        </a>
    
    
        <div class="login-register">
            <div class="title">
                <img src="{{siteDada?.headerLogo?.url ? siteDada?.headerLogo?.url:siteDada?.footerLogo?.url}}" alt="">
                <h3>Welcome Back!</h3>
            </div>
            <form [formGroup]="loginForm" (ngSubmit)="loginFormSubmission(loginForm.value)">
                <div class="form-group">
                    <input type="text" class="form-control login_section_input" id="singin-email-2" name="singin-email" placeholder="Email Id / Mobile Number *" formControlName="emailId" autocomplete="off">
                    <div *ngIf="loginSubmit && h.emailId.errors">
                        <div *ngIf="h.emailId.errors.required" class="help-box text-danger" style="font-size:12px;">
                            Email Id / Mobile Number is required
                        </div>
                        <!-- <div *ngIf=" h.emailId.errors.pattern" class="help-box text-danger" style="font-size:12px;">
                                Enter correct Email ID
                            </div> -->
                    </div>
                </div>
                <div class="form-group">
                    <input type="password" class="form-control login_section_input" id="singin-password-2" name="singin-password" placeholder="Password" formControlName="password" autocomplete="off">
                    <div *ngIf="loginSubmit && h?.password?.errors">
                        <div *ngIf="h?.password?.errors?.required" class="help-box text-danger" style="font-size:12px;">
                            Password is required</div>
                    </div>
                </div>
                <a class="forgot-link" tabindex="0" (click)="openPasswordReset()">Forgot Password ?</a>
                <div class="">
                    <button type="submit" tabindex="0" role="button">
                        <span>Sign In</span>
                    </button>
                </div>
                <div class="form-choice">
                    <p class="text-center">
                        <a class="" (click)="openRegister()"  tabindex="0" >
                            Create Account
                        </a>
                    </p>
                </div>
            </form>
        </div>
    </div>


<div id="mySideRegister" class="sideRegister" tabindex="-1">
    <a href="javascript:void(0)" id="closenow" class="closebtn cursor" (click)="closeRegister()" (keydown.enter)="closeRegister()">
        <i class="fa fa-close"></i>
    </a>
    <div class="login-register2">
        <div class="title">
            <img src="{{siteDada?.headerLogo?.url ? siteDada?.headerLogo?.url:siteDada?.footerLogo?.url }}" alt="">
            <h3>Enjoy special offers and discounts!</h3>
        </div>
        <form [formGroup]="registerForm">
            <div class="form-group">
                <input type="text" class="form-control login_section_input" placeholder="First Name" formControlName="firstName" autocomplete="off" (keypress)="lettersOnly($event)">
                <div *ngIf="submitted && g?.firstName?.errors">
                    <div *ngIf="g?.firstName?.errors?.required" class="help-box text-danger" style="font-size:12px;">
                        First
                        name is required</div>
                </div>
            </div>
            <div class="form-group">
                <input type="text" class="form-control login_section_input" placeholder="Last Name" formControlName='lastName' autocomplete="off" (keypress)="lettersOnly($event)">
                <div *ngIf="submitted && g?.lastName?.errors">
                    <div *ngIf="g?.lastName?.errors?.required" class="help-box text-danger" style="font-size:12px;">Last
                        name is required</div>
                </div>
            </div>
            <div class="form-group">
                <input type="text" class="form-control login_section_input" placeholder="Email" formControlName="emailId" autocomplete="off" (keyup)="onEmail($event)">
                <div *ngIf="submitted && g?.emailId?.errors">
                    <div *ngIf="g?.emailId?.errors?.required" class="help-box text-danger" style="font-size:12px;">
                        Email Id is required
                    </div>
                    <div *ngIf=" g?.emailId?.errors?.pattern" class="help-box text-danger" style="font-size:12px;">
                        Enter correct Email ID
                    </div>
                </div>
            </div>

            <div class="form-group">
                <input type="text" class="form-control login_section_input" placeholder="Mobile" formControlName="mobile" minlength="10" maxlength="10" onkeypress='return event.charCode >= 48 && event.charCode <= 57'>

                <div *ngIf="submitted && g?.mobile?.errors">
                    <div *ngIf="g?.mobile?.errors?.required" class="help-box text-danger" style="font-size:12px;">Mobile
                        is
                        required</div>
                    <div *ngIf="g?.mobile?.errors?.minlength" class="help-box text-danger" style="font-size:12px;">
                        Mobile number must be at least 10 digit long.</div>

                </div>
            </div>

            <!-- start work for date selector -->
            <label class="labelFordate_news" for="dob">Date of Birth</label>

            <div class="row">

                <div class="col-4">
                    <div class="form-group">
                        <label class="labelFordate_new" for="dob">Day</label>

                        <mat-form-field style="display: contents;">
                            <select matNativeControl [(ngModel)]="semical.selectdays" required [ngModelOptions]="{standalone: true}" id="selectMonth" (change)="onSelectDay(semical?.selectdays)" class="DOB_NEW">
                                <option value="" disabled selected>Day</option>
                                <option *ngFor="let dd of daysArray" [value]="dd?.value">
                                    {{dd.value}}</option>
                            </select>

                            <div *ngIf="submitted && semical?.selectdays ==undefined">
                                <div *ngIf="semical?.selectdays ==undefined" class="help-box text-danger" style="font-size:12px;">Day required</div>
                            </div>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-4">
                    <label class="labelFordate_new" for="dob">Month</label>
                    <mat-form-field style="display: contents;">
                        <select matNativeControl (change)="onSelectMonth(semical?.selectmonths)" [(ngModel)]="semical.selectmonths" [ngModelOptions]="{standalone: true}" required id="selectMonth" class="DOB_NEW">
                            <option value="" disabled selected>Month</option>
                            <option *ngFor="let month of monthlist" [value]="month?.value">{{month.text}}</option>
                        </select>
                        <div *ngIf="submitted && semical?.selectmonths ==undefined">
                            <div *ngIf="semical?.selectmonths ==undefined" class="help-box text-danger" style="font-size:12px;">Month required</div>
                        </div>
                    </mat-form-field>

                </div>
                <div class="col-4">
                    <div class="form-group">
                        <label class="labelFordate_new" for="dob">Year</label>
                        <mat-form-field style="display: contents;" class="New_bdk">
                            <select matNativeControl (change)="onSelectYear(semical.selectyear)" [(ngModel)]="semical.selectyear" required [ngModelOptions]="{standalone: true}" id="selectMonth" class="DOB_NEW">
                                <option value="" disabled selected>Year</option>
                                <option *ngFor="let year of years" [value]="year?.value">
                                    {{year.text}}</option>
                            </select>

                            <div *ngIf="submitted && semical?.selectmonths ==undefined">
                                <div *ngIf="semical?.selectmonths ==undefined" class="help-box text-danger" style="font-size:12px;">Year required</div>
                            </div>
                        </mat-form-field>
                    </div>
                </div>

            </div>

            <div class="form-group">
                <input type="password" class="form-control login_section_input" id="singin-password-3" [type]="newPassTextType ? 'text' : 'password'" name="singin-password" placeholder="Password" formControlName='password' autocomplete="off" required>
                <span class="fa " [ngClass]="{
                        'fa-eye-slash': !newPassTextType,
                        'fa-eye': newPassTextType
                      }" (click)="toggleNewPassword()"></span>

                <div *ngIf="submitted && g?.password?.errors">
                    <div *ngIf="g?.password?.errors?.required" class="help-box text-danger" style="font-size:12px;">
                        Password is required!
                    </div>
                    <div *ngIf="g?.password?.errors?.minlength" class="help-box text-danger" style="font-size:12px;">
                        Password length must be atleast 6
                    </div>

                </div>
            </div>
            <div class="form-group">

                <input type="password" class="form-control login_section_input" id="singin-password-4" [type]="cnfmPassTextType ? 'text' : 'password'" name="singin-password" placeholder="Confirm Password" formControlName='confirmPassword' autocomplete="off" required>
                <span class="fa" [ngClass]="{
                        'fa-eye-slash': !cnfmPassTextType,
                        'fa-eye': cnfmPassTextType
                      }" (click)="toggleCnfmPassword()"></span>

                <div *ngIf="submitted && g.confirmPassword.errors">
                    <div *ngIf="g?.confirmPassword?.errors?.confirmMatch" class="help-box text-danger" style="font-size:12px;">Confirm password must match with password</div>
                    <div *ngIf="g?.confirmPassword?.errors?.required" class="help-box text-danger" style="font-size:12px;">
                        Confirm Password is required!
                    </div>
                    <div *ngIf="g?.confirmPassword?.errors?.minlength" class="help-box text-danger" style="font-size:12px;">Confirm Password length must be atleast
                        6
                    </div>
                </div>
            </div>
            <div class="">
                <button type="submit" [disabled]="disableBTN" (click)="registerFormSubmission(registerForm?.value)" (keydown.enter)="registerFormSubmission(registerForm?.value)">
                    <span>Sign Up</span>
                </button>
            </div>
            <div class="form-choice">
                <p class="text-center">
                    Already have an account?
                    <a routerLink="/login" class="">
                        Sign In
                    </a>
                </p>
            </div>
        </form>
    </div>
</div>

<div id="mySideMobileVerify" class="sideRegister" tabindex="-1">

    <div class="login-register2">
        <div class="new_mobile_verification_section">
            <figure class="new_mobile_verification_img">
                <img src="{{siteDada?.footerLogo?.url}}" class="" alt="">
            </figure>
            <div class="title">
                <h5>Sign up to keep ordering amazing products!</h5>
                <p class="newpara"> Submit your phone number. We'll send you a 6 digit code via SMS so we know you're
                    real.</p>
            </div>

            <div class="form-group new_mobile_verification" id='otp'>
                <div class="new_fullwidth_phone_box">
                    <img src="assets/images/canadian.png">
                    <span class="ms-1">(+1)</span>
                    <input type="tel" [(ngModel)]="mobileNo" [ngModelOptions]="{standalone: true}" id="mobileNo" style="width: 175px;" name="mobileNo" required maxlength="10" minlength="10" #uname="ngModel">
                </div>
                <div *ngIf="isSubmitted && mobileNo ==undefined" style="color: red;">
                    Mobile number is required
                </div>
                <div *ngIf="uname?.errors?.minlength" style="color: red;">
                    Mobile number must be at least 10 digit long.
                </div>
            </div>
            <div class="">
                <button (click)="otpFormSubmission()" (keydown.enter)="otpFormSubmission()">
                    <span>Next</span>
                </button>
            </div>
        </div>
    </div>
</div>

<div id="mySideOtpVerify" class="sideRegister" tabindex="-1">

    <div class="login-register2">
        <div class="new_opt_vertfication">
            <figure class="new_mobile_verification_img">
                <img src="{{siteDada?.footerLogo?.url}}" class="" alt="">
            </figure>
            <div class="title">
                <h5>Verify your Mobile number</h5>
                <p class="newpara">Enter your 6 digit code here</p>
            </div>
            <div class="form-group" style="text-align: center;">

                <div class="form-group Login_new_opt_page" id='otp'>
                    <input type="text" class="form-control" name="otp" onkeypress='return event.charCode >= 48 && event.charCode <= 57' (keyup)="otpLenth()" maxlength="6" autocomplete="one-time-code" minlength="6" [(ngModel)]="otp">
                </div>
                <div *ngIf="otpSubmitted && (otp ==undefined || otp=='')" style="color: red;">
                    Otp is required
                </div>
                <div *ngIf="otpSubmitted && otpLength" style="color: red;">
                    Otp must be at least 6 digit long.
                </div>
            </div>
            <div class="">
                <button (click)="verificationFormSubmission()" (keydown.enter)="verificationFormSubmission()">
                    <span>Verify Code</span>
                </button>
                <br><br>
                <span *ngIf="display !='00'" class="cursor" style="font-size: 12px;"> Resend Verification Code</span>
                <br><br>
                <a *ngIf="resendOtp && display =='00'" (click)="resendOTP()" (keydown.enter)="resendOTP()" class="cursor"> Resend Verification Code?
                </a>
                <span><a class="cursor" (click)="changeMobileNumber()" (keydown.enter)="changeMobileNumber()"> Change Mobile Number? </a></span>
            </div>
        </div>
    </div>
</div>


<div id="mySideForgotPassword" class="sideRegister" tabindex="-1">
    <a href="javascript:void(0)" class="closebtn" tabindex="0" (click)="closePassReset()" (keydown.enter)="closePassReset()"> 
        <i class="fa fa-close"></i>
    </a>
    <div class="login-register2">
        <div class="title">
            <img src="{{siteDada?.headerLogo?.url ? siteDada?.headerLogo?.url:siteDada?.footerLogo?.url}}" alt="">
            <h3>Password Reset</h3>
        </div>
        <form [formGroup]="forgotPassword" (ngSubmit)="forgotPasswordSubmission(forgotPassword.value)">
            <div class="form-group">
                <label for="singin-email-2" style="font-weight:600;">Email ID</label>
                <input type="text" class="form-control" id="singin-email-1" name="singin-email" formControlName="emailId" placeholder="Enter your register email">
            </div>
            <div *ngIf="submitted && f?.emailId?.errors">
                <div *ngIf="f?.emailId?.errors?.required" class="help-box text-danger" style="font-size:12px;">
                    Email Id is required
                </div>
                <div *ngIf="f?.emailId?.errors?.email" class="help-box text-danger" style="font-size:12px;">
                    Enter correct Email ID
                </div>
            </div>
            <div class="">
                <button type="submit" class="btn btn-outline-primary-2">
                    <span>Submit</span>
                    <i class="icon-long-arrow-right"></i>
                </button>
            </div>
        </form>
    </div>
</div>